import classNames from "classnames";
import {forwardRef, useState} from "react";
import {Alert as BSAlert} from "react-bootstrap";
import {FiX} from "react-icons/fi";

import {AlertComponent, AlertProps} from "@/components/alert/Alert.types.ts";
import {AlertBody} from "@/components/alert/subComponents/AlertBody/AlertBody.tsx";
import {AlertHeader} from "@/components/alert/subComponents/AlertHeader/AlertHeader.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {IconButton} from "@/components/iconButton/IconButton.tsx";

import styles from "./Alert.module.scss";

const AlertBase = forwardRef<HTMLDivElement, AlertProps>(
  (
    {
      variant = "default",
      size = "small",
      header,
      callout,
      show: showProp,
      className,
      icon,
      dismissible,
      onClear,
      children,
      contentClassName,
      typography = "body",
      action,
      ...rest
    },
    ref
  ) => {
    const [internalShow, setInternalShow] = useState(true);

    const handleClose = () => {
      setInternalShow(false);
      onClear?.();
    };

    const show = showProp !== undefined ? showProp : internalShow;

    return (
      <BSAlert
        ref={ref}
        show={show}
        className={classNames(styles.alert, styles[variant], styles[size], styles[typography], className)}
        bsPrefix={"custom-alert"}
        {...rest}
      >
        {size === "large" ? (
          <>
            {header && (
              <AlertHeader dismissible={dismissible} onClose={handleClose}>
                {header}
              </AlertHeader>
            )}
            <AlertBody>{children}</AlertBody>
          </>
        ) : (
          <>
            {icon && <Icon icon={icon} className={styles.icon} />}
            <div className={classNames(styles.contentWrapper, contentClassName)}>
              {callout && <span className={styles.callout}>{callout} —&nbsp;</span>}
              <span className={styles.content}>{children}</span>
            </div>
            {action}
            {dismissible && <IconButton variant={"ghost"} size={"fitIcon"} onClick={handleClose} icon={FiX} />}
          </>
        )}
      </BSAlert>
    );
  }
);

AlertBase.displayName = "Alert";

export const Alert = Object.assign(AlertBase, {
  Header: AlertHeader,
  Body: AlertBody,
}) as AlertComponent;
